<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template v-slot:left_view>
            <GnbPmCounterLeftTree ref="GnbPmCounterLeftTree" @gnbCounterTreeClick="gnbCounterTreeClick"></GnbPmCounterLeftTree>
        </template>
        <template v-slot:right_view>
            <GnbPmCounterRightContent :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo"></GnbPmCounterRightContent>
        </template>
    </BasicLayout>
</template>

<script>
    import BasicLayout from "../../../layouts/BasicLayout";
    import GnbPmCounterLeftTree from "../../../components/pmConfig/gnb/PmCounterManagementForGnb/Left/GnbPmCounterLeftTree";
    import GnbPmCounterRightContent from "../../../components/pmConfig/gnb/PmCounterManagementForGnb/Right/GnbPmCounterRightContent";

    export default {
        name: 'PmCounterManagementForGnb',
        components: {
            BasicLayout,
            GnbPmCounterLeftTree,
            GnbPmCounterRightContent
        },
        data() {
            return {
                left: {
                    show: true,
                    name: this.$t('Pm.counterManagement')
                },
                middle: {
                    show: false,
                    name: ''
                },
                right: {
                    show: true,
                    crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.gnbManagement')}/${this.$t('Pm.counterManagement')}`
                },
                gnbCounterTreeClickInfo: {}
            };
        },
        methods: {
            gnbCounterTreeClick(treeInfo){
                this.gnbCounterTreeClickInfo = treeInfo;
            }
        },
    };
</script>

<style>

</style>
